import {
  SiteVerify,
  siteVerify,
  createTask,
  CreateTaskData,
  getTemplate,
  GetTemplate,
  GetDetail,
  getDetail,
  GetSiteList,
  getSiteList,
  deleteSite,
  DeleteSite,
  SiteDial,
  siteDial,
  EditSiteData,
  editTask,
  getSiteOs,
  getSiteDb,
  getSiteType,
  postIdentification,
  PostIdentification,
  getLanguage,
  download,
  Download,
  getUserDomain,
  DownloadAuth,
  downloadAuth,
  CheckSiteName,
  checkSiteName,
  getSiteArea,
  getSiteDeviceList,
  getComponentList,
  // downloadFailedFile,
  checkWafSite,
} from '@/api/waf-create-task'
import { Message } from '@/components/message'
import { useRequest } from 'ahooks'
// import { message } from 'antd'
import { configSite, deviceProducer } from '@/api/waf-site'
// 站点资源列表
export const useGetSiteList = () => {
  const {
    data,
    runAsync: run,
    loading,
  } = useRequest((datas: GetSiteList) => getSiteList(datas), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '站点资源列表获取失败')
    },
  })
  return [data?.data || [], run, loading] as const
}
// 获取站点资源详细
export const useGetDetail = () => {
  const { data, runAsync: run } = useRequest((datas: GetDetail) => getDetail(datas), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || '站点资源详细获取失败')
    },
  })
  return [data?.data || [], run] as const
}
// 获取模板分组
export const useGetTemplate = () => {
  const {
    runAsync: run,
    loading,
    data,
  } = useRequest((datas: GetTemplate) => getTemplate(datas), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取分组列表失败')
    },
  })

  return [run, loading, data?.data || []] as const
}
// 站点认证
export const useSiteVerify = () => {
  const { runAsync: run, loading } = useRequest((data: SiteVerify) => siteVerify(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '站点认证失败')
    },
  })

  return [run, loading] as const
}
// 删除站点资源
export const useDeleteSite = () => {
  const { runAsync: run, loading } = useRequest((data: DeleteSite) => deleteSite(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '删除站点资源失败')
    },
  })

  return [run, loading] as const
}
// 添加站点资源
export const useCreateTask = () => {
  const { runAsync, loading } = useRequest((data: CreateTaskData) => createTask(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '添加站点资源失败')
    },
  })
  return [runAsync, loading] as const
}
// 网址认证
export const useSiteDial = () => {
  const { runAsync: run, loading } = useRequest((data: SiteDial) => siteDial(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '网址认证失败')
    },
  })
  return [run, loading] as const
}
// 修改站点资源
export const useEditSite = () => {
  const { runAsync: run, loading } = useRequest((data: EditSiteData) => editTask(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '修改站点资源失败')
    },
  })
  return [run, loading] as const
}
export const useGetSiteOs = () => {
  const { data, runAsync, loading } = useRequest(() => getSiteOs(), {
    // manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取操作系统失败')
    },
  })
  return [data?.data || [], runAsync, loading] as const
}
export const useGetSiteDeviceList = () => {
  const { data, runAsync, loading } = useRequest(() => getSiteDeviceList(), {
    // manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取设备失败')
    },
  })
  return [data?.data?.items || [], runAsync, loading] as const
}
export const useGetSiteDb = () => {
  const { data, runAsync, loading } = useRequest(() => getSiteDb(), {
    // manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取数据库失败')
    },
  })
  return [data?.data || [], runAsync, loading] as const
}
export const useGetSiteType = () => {
  const { data, runAsync, loading } = useRequest(() => getSiteType(), {
    // manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取设备厂商失败')
    },
  })
  return [data?.data || [], runAsync, loading] as const
}
export const usePostIdentification = () => {
  const { runAsync, loading } = useRequest((data: PostIdentification) => postIdentification(data), {
    manual: true,
    onError(err: any) {
      // Message.error(err?.msg || '')
    },
  })
  return [runAsync, loading] as const
}
// 获取开发语言
export const useGetLanguage = () => {
  const { runAsync, data, loading } = useRequest(() => getLanguage(), {
    // manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取开发语言失败')
    },
  })
  return [runAsync, data?.data?.items, loading] as const
}
//下载授权文件
export const useDownload = () => {
  const { runAsync, data, loading } = useRequest((datas: Download) => download(datas), {
    manual: true,
    onError(err: any) {
      // Message.error(err?.msg || '下载授权文件失败')
    },
  })
  return [runAsync, data?.data?.items, loading] as const
}
//获取用户domain
export const useGetUserDomain = () => {
  const { runAsync, data, loading } = useRequest(() => getUserDomain(), {
    onError(err: any) {
      Message.error(err?.msg)
    },
  })
  return [runAsync, data?.data, loading] as const
}
//获取用户domain
export const useDownloadAuth = () => {
  const { runAsync, loading } = useRequest((data: DownloadAuth) => downloadAuth(data), {
    manual: true,
    onError(err: any) {},
  })
  return [runAsync, loading] as const
}
//检查站点名称是否存在
export const useCheckSiteName = () => {
  const { runAsync: run, loading } = useRequest((data: CheckSiteName) => checkSiteName(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '检查站点名称失败')
    },
  })
  return [run, loading] as const
}
//获取安全域
export const useGetSiteArea = () => {
  const {
    runAsync: run,
    data,
    loading,
  } = useRequest(() => getSiteArea(), {
    // manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取安全域失败')
    },
  })
  return [run, data?.data?.items || [], loading] as const
}

export const useGetComponentList = () => {
  const { data, runAsync, loading } = useRequest(() => getComponentList(), {
    // manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取影响组件失败')
    },
  })
  return [data?.data?.items || [], runAsync, loading] as const
}

// export const useDownloadFailedData = () => {
//   const
// }

export const useCheckWafSite = () => {
  const { data, runAsync, loading } = useRequest(param => checkWafSite(param), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '检查站点失败')
    },
  })
  return [data?.data || [], runAsync, loading] as const
}

export const useConfigSite = () => {
  const { runAsync, loading } = useRequest(param => configSite(param), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '配置站点失败')
    },
  })
  return [runAsync, loading] as const
}

export const useGetDeviceProducer = () => {
  const { data, runAsync, loading } = useRequest(() => deviceProducer(), {
    // manual: true,
    onError(err: any) {
      Message.error(err?.msg || '检查站点失败')
    },
  })
  return [data?.data || [], runAsync, loading] as const
}
